import { useRef, PropsWithChildren, useEffect } from 'react';
import clsx from 'clsx';
import { useStyles } from './toggle-box.style';
import { generateUniqueId } from '../../shared/helpers/helpers';

type ToggleBoxProps = {
    /**
     * Trigger toggle behaviour
     */
    isExpand: boolean;
    /**
     * Able to style the component
     */
    wrapperClass?: string;
    /**
     * for better accessibility if you are controlling from button
     */
    ariaLabelledby?: string;
    /**
     * Need to pick the element or better accessibility
     */
    id?: string;
};

const ToggleBox = (props: PropsWithChildren<ToggleBoxProps>): JSX.Element => {
    const classes = useStyles();
    const toggleRef = useRef(null);

    useEffect(() => {
        if (toggleRef && props.isExpand) {
            const element = toggleRef.current as unknown as HTMLDivElement;
            element.style.maxHeight = `${element.scrollHeight}px`;
        } else {
            const element = toggleRef.current as unknown as HTMLDivElement;
            element.style.maxHeight = '0px';
        }
    }, [props.isExpand]);

    return (
        <div
            ref={toggleRef}
            id={props.id ? props.id : `toggle-box-${generateUniqueId()}`}
            className={classes.wrapper}
            aria-labelledby={props.ariaLabelledby ? props.ariaLabelledby : ''}
        >
            <div className={clsx(props.wrapperClass ? props.wrapperClass : '')}>{props.children}</div>
        </div>
    );
};

export { ToggleBox };
export type { ToggleBoxProps };
